import React, { Suspense, useEffect, useState } from 'react';
import ForgeReconciler, { Spinner, Text } from '@forge/react';
import { view } from '@forge/bridge';
import { JiraUserContextProvider } from '../libs/JiraUserContextProvider';
import { getModule } from './getModule';
import { Logger } from '@app/booking-libs';
const log = new Logger('UiModuleLoader');
function UiLazyLoader() {
    const [module, setModule] = useState('');
    useEffect(() => {
        view.getContext().then((context) => {
            log.debug(`Loading ${context.moduleKey}`);
            setModule(context.moduleKey);
        });
    }, []);
    if (!module) {
        return React.createElement(Spinner, { label: 'loading' });
    }
    const Module = getModule(module);
    if (!Module) {
        log.error(`Module name ${module} does not exist`);
        return React.createElement(Text, null,
            "Module name ",
            module,
            " does not exist");
    }
    return (React.createElement(Suspense, { fallback: React.createElement(Spinner, { label: 'Loading module' }) },
        React.createElement(Module, null)));
}
ForgeReconciler.render(React.createElement(React.StrictMode, null,
    React.createElement(JiraUserContextProvider, null,
        React.createElement(UiLazyLoader, null))));
